import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { LatestUpdate } from "../models/latestupdate";
import { LatestUpdateService } from "../services/latestupdate.service";
import { Observable } from "rxjs";

@Injectable()
export class LatestUpdateResolver implements Resolve<LatestUpdate> {

    constructor(private latestUpdateService: LatestUpdateService) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<LatestUpdate> {
        if (route.params["id"] === undefined || route.params["id"] === "0") {
            return null;
        }
        // todo: route.params["id"] - explicitly passsing it as 4 at the moment.
        return this.latestUpdateService.getUpdate(route.params["id"]);
    }
}
